module.exports = __webpack_public_path__ + "static/media/INCH.1b1abd4e.png";